// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1234":"cb56378b","3785":"cb56378b","5056":"2d78d870"}[chunkId] + ".css";
};